module.exports = __webpack_public_path__ + "static/media/ic-accept.f4d36396.svg";